import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import Config from "../config/Config.js";
import {
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
} from "../components/auth/AuthActions";

import ProjectCard from "../components/project/ProjectCard";
import SweetLoadingSpinner from "../components/eyeCandy/SweetLoadingSpinner";

const SearchResultsPage = () => {
  const auth = RESOLVE_LOCAL_AUTH_STATE();
  const user = RESOLVE_LOCAL_USER_STATE();

  const [searchParams] = useSearchParams();
  const q = searchParams.get("search") || "";

  const [loading, setLoading] = useState(true);
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    axios
      .get(`${Config().baseUrl}?search=${encodeURIComponent(q)}`)
      .then((res) => {
        const data = res.data;
        if (!cancelled) setSearchResults(Array.isArray(data) ? data : data.results || []);
      })
      .catch((err) => {
        console.error('Search Results Error:', err);
        console.error('Search Results Error Response:', err.response);
        console.error('Search Results Error Status:', err.response?.status);
        console.error('Search Results Error Data:', err.response?.data);
        if (!cancelled) setSearchResults([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [q]);

  return (
    <div className="container" style={{ paddingTop: "50px" }}>
      <h6>
        Search results for "<strong>{q}</strong>"...
      </h6>
      <hr />
      <SweetLoadingSpinner loadingState={loading} />
      <div className="row">
        {searchResults.map((project) => (
          <ProjectCard project={project} key={project.id} />
        ))}
      </div>
    </div>
  );
};

export default SearchResultsPage;
